import { Directive } from '@angular/core';

import {
  AbstractControl,
  NG_VALIDATORS,
  Validator,
} from '@angular/forms';

@Directive({
  selector: '[ld-mustcheck][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: MustCheckValidatorDirective, multi: true }
  ]
})
export class MustCheckValidatorDirective implements Validator {
  validate(c: AbstractControl) {
    if (c.value !== true) {
      return {mustBeCheckedError: 'Must be checked'};
    }
    return null;
  }
}
